// @ts-strict-ignore
import { useEffect, useState } from 'react';

import { TileCarouselResult } from 'api/types/shared.types';
import { JobFunction } from 'utils/constants';
import { getRecommendedJobs } from 'utils/getRecommendedJobs';

type Props = {
  searchLocation: Partial<SearchLocation> &
    Pick<SearchLocation, 'latitude' | 'longitude'>;
  options: {
    onlyWithLogo?: boolean;
    jobFunction?: JobFunction;
    familyId?: string;
  };
};

export function useCarouselRecommendedJobs({
  searchLocation,
  options: { onlyWithLogo, jobFunction, familyId },
}: Props): TileCarouselResult[] {
  const [recommendedJobs, setRecommendedJobs] = useState<TileCarouselResult[]>(
    []
  );
  useEffect(() => {
    getRecommendedJobs({
      searchLocation,
      options: {
        onlyWithLogo,
        jobFunction,
        familyId,
      },
    }).then((jobs) => {
      setRecommendedJobs(
        jobs.map((job) => ({
          city: job.city,
          id: job.objectID,
          logo: job.logo,
          orgName: job.orgName,
          name: job.name,
          state: job.state,
          url: job.url,
        }))
      );
    });
  }, [searchLocation, onlyWithLogo, jobFunction, familyId]);
  return recommendedJobs;
}
